export const API_dashboard_current = (): string => '/api/v2/dashboard/current';
export const API_dashboard_report = (): string => '/api/v2/dashboard/report';
export const API_dashboard_events = (): string => '/api/v2/dashboard/events';
export const API_dashboard_stacked_status = (): string => '/api/v2/dashboard/current-stacked';
export const API_dashboard_activities = (): string => '/api/v2/activities';
export const API_dashboard_cost_comparison = (): string => '/api/v2/dashboard/cost-comparison';
export const API_dashboard_value_breakdown = (): string => '/api/v2/dashboard/value-breakdown';
